module.exports = __webpack_public_path__ + "img/country_icon.3fd08881.svg";